import { boolean, defineAction, number, object, string } from '~/prix'
import attendanceAlertAction from './attendanceAlertAction.action.json'

const attendanceAlertActionDefinition = defineAction({
  ...attendanceAlertAction,
  input: object({
    action: string(),
    token: string().isOptional(),
  }),
  output: object({
    success: boolean(),
    reason: string().isOptional(),
    action: string().isOptional(),
    incidentId: string().isOptional(),
    recipientId: number().isOptional(),
    email: string().isOptional(),
  }),
})

export default attendanceAlertActionDefinition

